module.exports = __webpack_public_path__ + "static/media/icon-building-light.3cb1ebe3.svg";